import { http } from 'http';

export default {
  getSectionDataByEntity: entity => http.get(`/masterdata/filters/stratos/${entity}`),

  getBrands: () => http.get('/catalog/GetBrands'),

  getModelByBrand: mark => http.get(`/catalog/getModelByBrand/${mark}`),

  getVehicleTypeByBrand: mark => http.get(`/catalog/getVehicleTypeByBrand/${mark}`),

  getImagesBenchBrands: ({ shellType, location }) =>
    http.get(`/VehicleImages/Brands/${shellType}/${location}`),

  getImagesBenchModel: ({ shellType, location, brand }) =>
    http.get(`/VehicleImages/Models/${shellType}/${location}/${brand}`),

  getImagesBenchVersion: ({ shellType, location, brand, model }) =>
    http.get(`/VehicleImages/Versions/${shellType}/${location}/${brand}/${model}`),

  getImagesBenchVehicle: ({ shellType, location, brand, model, version }) =>
    http.get(`/VehicleImages/vehicles/${shellType}/${location}/${brand}/${model}/${version}`)
};
